import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, compactQuery, floatingSurfaceCss, hoverQuery, selectedRingCss } from '../theme';

const styles = {
  grid: css`
    display: flex;
    gap: ${af.sp3};
    /* Equal height via stretch, so two cards of different copy length still align. */
    align-items: stretch;

    ${compactQuery} {
      flex-direction: column;
    }
  `,

  root: css`
    ${bareButtonCss};
    ${floatingSurfaceCss};
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: ${af.sp3};
    padding: 22px;
    text-align: left;
    position: relative;
    transition: box-shadow 0.12s ease;

    /* Pointer devices only: on touch the state would stick to the tapped card. */
    ${hoverQuery} {
      &:hover:not([aria-checked='true']) {
        box-shadow:
          ${af.shadowCard},
          inset 0 0 0 1px ${af.line};
      }
    }
  `,

  selected: css`
    ${selectedRingCss};

    ${hoverQuery} {
      &:hover {
        ${selectedRingCss};
      }
    }
  `,

  /** Bare outline icon at 26px in ink — no chip, no container. */
  icon: css`
    width: 28px;
    height: 28px;
    color: ${af.ink};
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  /** Leaves room for the radio mark in the top-right corner. */
  label: css`
    display: block;
    padding-right: 26px;
  `,

  description: css`
    display: block;
    margin-top: ${af.sp1};
  `,

  check: css`
    position: absolute;
    top: 14px;
    right: 14px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1.5px solid ${af.line};
    background: ${af.paper};
  `,

  checkSelected: css`
    border-color: ${af.ink};
    background: ${af.ink};

    &::after {
      content: '';
      position: absolute;
      inset: 5px;
      border-radius: 50%;
      background: ${af.paper};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
